"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const antd_1 = require("antd");
const react_1 = __importDefault(require("react"));
const react_router_dom_1 = require("react-router-dom");
const logo_360_oficial_webp_1 = __importDefault(require("../../../../../assets/images/logo_360_oficial.webp"));
const RoutesPaths_1 = require("../../../../../routes/RoutesPaths");
require("./NoReserves.scss");
const NoReserves = () => {
    return (react_1.default.createElement("div", { className: "NoReserves" },
        react_1.default.createElement("img", { src: logo_360_oficial_webp_1.default, alt: "" }),
        react_1.default.createElement("span", { className: "message" }, "Opsss... Parece que voc\u00EA ainda n\u00E3o possui reservas"),
        react_1.default.createElement(react_router_dom_1.Link, { to: RoutesPaths_1.routesPaths.bookSuite, className: "linkToBookSuite" },
            react_1.default.createElement(antd_1.Button, { type: "primary" },
                react_1.default.createElement("span", null, "Fa\u00E7a uma reserva agora mesmo!")))));
};
exports.default = NoReserves;
